<template>
  <navi-bar>
    <img src="@/assets_mobile/img/headin_off.png"/>
    <span>{{$t('front.common.depositApply')}}<em>Deposit</em></span>
  </navi-bar>
  <section class="cash-box">
    <template v-if="type == 'apply'">
      <div class="chargewrap">
        <div>
          <h3>입금시 주의사항</h3>
          <ul class="notice">
            <li>1. <em>23:50~00:20</em> 입금 점검 시간으로 입금 불가.</li>
            <li>2. 1회 최대 입금 500만원 1만원 단위 만 입금 가능.</li>
            <li>3. 1000만원 입금 시 500만원 2번 입금 부탁 드립니다.</li>
            <li>4.수표입금 불가</li>
            <li>5. 등록하신 계좌 전용어플 사용 부탁드립니다.</li>
          </ul>
        </div>
        <div>
          <h3>입금신청
            <a class="acountbtn"  @click="getAcc">계좌요청</a>
          </h3>
          <div class="cash">
            <input type="text" pattern="[0-9.,]+" class="numb" :placeholder="$t('front.give.moneyInput')" v-model="setCurrentChargeMoney"/>
            <ul class="applimoneybtn">
              <li class=""><a @click="setMoney(10000)">1{{$t('front.cash.manwon')}}</a></li>
              <li class=""><a @click="setMoney(30000)">3{{$t('front.cash.manwon')}}</a></li>
              <li class=""><a @click="setMoney(50000)">5{{$t('front.cash.manwon')}}</a></li>
              <li class=""><a @click="setMoney(100000)">10{{$t('front.cash.manwon')}}</a></li>
              <li class=""><a @click="setMoney(300000)">30{{$t('front.cash.manwon')}}</a></li>
              <li class=""><a @click="setMoney(500000)">50{{$t('front.cash.manwon')}}</a></li>
              <li class=""><a @click="setMoney(1000000)">100{{$t('front.cash.manwon')}}</a></li>
              <li class=""><a @click="setMoney(2000000)">200{{$t('front.cash.manwon')}}</a></li>
              <li class=""><a @click="setMoney(5000000)">500{{$t('front.cash.manwon')}}</a></li>
              <li class="bgc"><a @click="setCurrentChargeMoney = ''">정정</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="applybtnwrap">
        <a class="acountbtn" @click="onSubmit">{{$t('front.board.apply')}}</a>
      </div>
    </template>
  </section>
  <section class="sub-box">
    <template v-if="type == 'apply'">
      <!-- <date-filter-mobile @search="onCashListSearch"
                          @update="onChangeDate"
      /> -->
      <div class="mboard">
        <ul class="boardw first">
          <li class="">{{$t('front.board.processMoney')}}</li>
          <li class="">{{$t('front.board.processState')}}</li>
          <li class="">{{$t('front.board.applyDay')}}</li>
          <li class="">{{$t('front.board.processDay')}}</li>
        </ul>
        <template v-if="cashList.length > 0">
          <ul class="boardw" v-for="item in cashList" v-bind:key="item.cashIdx">
            <li class="">{{thousand(item.cashAmt)}}</li>
            <li class=""><span>{{computedCashStatus(item.cashStatus).text}}</span></li>
            <li class="">{{dateFormat(item.regDate)}}</li>
            <li class="">{{dateFormat(item.updDate)}}</li>
          </ul>
        </template>
        <template v-else>
          <ul class="boardw">
            <li>{{$t('front.common.notFoundList')}}</li>
          </ul>
        </template>
      </div>
      <!-- <div class="gamebetwrap">
        <template v-if="cashList.length > 0">
          <div class="gamebetlist" v-for="item in cashList" v-bind:key="item.cashIdx">
            <ul class="gamebetdetail">
              <li class="date"><em>{{computedCashStatus(item.cashStatus).text}}</em> ({{dateFormat(item.regDate)}})</li>
              <li><a class="close">{{$t('front.board.delete')}}</a></li>
              <li>{{$t('front.board.processMoney')}}</li>
              <li><span class="gn">{{thousand(item.cashAmt)}}</span> {{$t('front.common.money')}}</li>
            </ul>
          </div>
        </template>
        <template v-else>
          <div class="gamebetlist">
            {{$t('front.common.notFoundList')}}
          </div>
        </template>
      </div> -->
      <pagination-mobile v-if="pageInfo"
                         :pageNum="pageInfo.page"
                         :pageSize="pageInfo.count_per_list"
                         :totalCount="pageInfo.tatal_list_count"
                         @goToPage="onCashListSearchMobile"
      />
    </template>

  </section>
</template>

<script>

import NaviBar from '@/components/common/mobile/NaviBar'
import PaginationMobile from '@/components/ui/PaginationMobile'
// import DateFilterMobile from '@/components/ui/DateFilterMobile'
import Charge from '@/views/member/money/charge'

export default {
  name: 'charge',
  data () {
    return {
      moneyinfo: false
    }
  },
  components: {
    NaviBar,
    // DateFilterMobile,
    PaginationMobile
  },
  mixins: [
    Charge
  ]
}
</script>
<style scoped src="@/styles_mobile/betlist.css"></style>
<style scoped src="@/styles_mobile/money.css"></style>
<style scoped src="@/styles_mobile/subcommon.css"></style>
<style scoped src="@/styles_mobile/common.css"></style>

<style>
.morebtn {margin-bottom: 10px !important;}
</style>
